import React from 'react';
import HtmlToReact from 'html-to-react';
import styles from './styles.module.scss';

export const HtmlBlock = ({ content, children }) => {
  const Parser = new HtmlToReact.Parser();
  return <div className={styles.html}>{Parser.parse(content || children)}</div>;
};
